<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step designProjectForm [stepControl]="designProjectForm">
    <form [formGroup]="designProjectForm" class="w-full">
      <ng-template matStepLabel>{{
        projectId ? ("UPDATE_PROJECT" | translate) : ("ADD_PROJECT" | translate)
      }}</ng-template>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-6">
          <mat-label>{{'ORG_NAME' | translate}}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_name" readonly />
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{'companyCode' | translate}}</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_code" readonly />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "PROJECT_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              formControlName="project_name"
              *ngIf="!proShow"
              readonly
            />
            <mat-select
              *ngIf="proShow"
              formControlName="project_id"
              (selectionChange)="onProjectChange($event.value)"
            >
              <mat-option value="">{{
                "SELECT_Project" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let project of projectList"
                [value]="project.id"
                >{{ project.project_name }}</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="
                designProjectForm.get('project_name')?.hasError('required')
              "
            >
              {{ "PROJECT_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6" *ngIf="branchShow">
          <mat-label
            >{{ "BRANCH" | translate }} <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <mat-select formControlName="branch_id">
              <mat-option value="">{{
                "SELECT_BRANCH" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let branch of branchList"
                [value]="branch.branch_id"
                >{{ branch.branch_name }}</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="designProjectForm.get('branch_id')?.hasError('required')"
            >
              {{ "BRANCH_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "Design_lead" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="design_lead" />

            <mat-error
              *ngIf="designProjectForm.get('design_lead')?.hasError('required')"
            >
              {{ "PROJECT_MANAGER_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "DOMAIN" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="full-width">
            <mat-select
              formControlName="domain"
              (selectionChange)="onDomainChange($event.value)"
            >
              <mat-option *ngFor="let domain of domainOptions" [value]="domain">
                {{ domain }}
              </mat-option>
            </mat-select>
            <!-- <mat-select formControlName="domain" required>
              <mat-option value="Commercial">Commercial</mat-option>
              <mat-option value="Consultancy">Consultancy</mat-option>
              <mat-option value="Education">Education</mat-option>
              <mat-option value="Electric">Electric</mat-option>
              <mat-option value="Gas">Gas</mat-option>
              <mat-option value="Power">Power</mat-option>
              <mat-option value="Residential">Residential</mat-option>
              <mat-option value="Road">Road</mat-option>
              <mat-option value="Telecom">Telecom</mat-option>
              <mat-option value="Water">Water</mat-option>
            </mat-select> -->
            <mat-error
              *ngIf="designProjectForm.get('domain')?.hasError('required')"
            >
              {{ "DOMAIN_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <ng-container *ngFor="let field of domainFields[selectedDomain]">
          <div class="col-span-4">
            <mat-label>{{ field.key | translate}}</mat-label>

            <mat-form-field
              appearance="outline"
              *ngIf="designProjectForm.get(field.key)"
            >
              <input
                matInput
                [type]="field.type"
                [formControlName]="field.key"
              />
            </mat-form-field>
          </div>
        </ng-container>

        <div class="col-span-6">
          <mat-label> {{ "design_software_used" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="design_software_used" />

            <mat-error
              *ngIf="
                designProjectForm
                  .get('design_software_used')
                  ?.hasError('required')
              "
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label> {{ "drawing_reference_code" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="drawing_reference_code" />

            <mat-error
              *ngIf="
                designProjectForm
                  .get('drawing_reference_code')
                  ?.hasError('required')
              "
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label> {{ "structural_design_type" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="structural_design_type" />

            <mat-error
              *ngIf="
                designProjectForm
                  .get('structural_design_type')
                  ?.hasError('required')
              "
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label> {{ "safety_standards" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="safety_standards" />

            <mat-error
              *ngIf="
                designProjectForm.get('safety_standards')?.hasError('required')
              "
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label> {{ "design_approval_status" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="design_approval_status" />

            <mat-error
              *ngIf="
                designProjectForm
                  .get('design_approval_status')
                  ?.hasError('required')
              "
            >
              {{ "DESCRIPTION_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label> {{ "START_DATE_" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [matDatepicker]="startPicker"
              formControlName="design_start_date"
              [max]="cValue"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>

            <mat-error
              *ngIf="
                designProjectForm.get('design_start_date')?.hasError('required')
              "
            >
              {{ "START_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "END_DATE_" | translate }} </mat-label>

          <mat-form-field appearance="outline" class="w-full">
            <input
              matInput
              [matDatepicker]="endPicker"
              formControlName="design_end_date"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>

            <mat-error
              *ngIf="
                designProjectForm.get('design_end_date')?.hasError('required')
              "
            >
              {{ "END_DATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!designProjectForm.valid"
        >
          {{ "NEXT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="locationForm">
    <form [formGroup]="locationForm" class="w-full">
      <ng-template matStepLabel>{{ "LOCATION" | translate }}</ng-template>

      <div formArrayName="location">
        <div
          *ngFor="let branch of location.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "COUNTRY" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select
                  formControlName="country"
                  (selectionChange)="onCountryBChange(i)"
                  required
                >
                  <mat-option value="">{{
                    "SELECT_COUNTRY" | translate
                  }}</mat-option>
                  <mat-option value="India">India</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('country')?.hasError('required')">
                  {{ "COUNTRY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "STATE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="state"
                  (selectionChange)="onStateBChange(i)"
                  required
                >
                  <mat-option value="">{{
                    "SELECT_STATE" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let state of availableStates[i]"
                    [value]="state"
                  >
                    {{ state }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('state')?.hasError('required')">
                  {{ "STATE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "CITY" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="city" required>
                  <mat-option value="">{{
                    "SELECT_CITY" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let city of availableCities[i]"
                    [value]="city"
                  >
                    {{ city }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('city')?.hasError('required')">
                  {{ "CITY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "POSTAL_CODE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Pincode"
                  formControlName="pincode"
                />
                <mat-error *ngIf="branch.get('pincode')?.hasError('required')">
                  {{ "PINCODE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label> {{ "line1" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_1" />
                <mat-error
                  *ngIf="branch.get('address_line_1')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label> {{ "line2" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_2" />
                <mat-error
                  *ngIf="branch.get('address_line_2')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <button
            mat-stroked-button
            type="button"
            (click)="openPicker(i, branch)"
          >
            {{ "locateOnMap" | translate }}
          </button>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "LAT" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput placeholder="Latitude" formControlName="lat" />
                <mat-error *ngIf="branch.get('lat')?.hasError('required')">
                  {{ "LAT_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-label>{{ "LONG" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="long" />
                <mat-error *ngIf="branch.get('long')?.hasError('required')">
                  {{ "LONG_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="false" class="form-actions mt-4 flex gap-4">
            <button
              *ngIf="location.length > 1"
              mat-raised-button
              color="warn"
              type="button"
              (click)="removeBranch(i)"
            >
              {{ "REMOVE" | translate }}
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="addBranch()"
            >
              {{ "ADD_BRANCH" | translate }}
            </button>
          </div>

          <mat-divider class="my-4"></mat-divider>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!locationForm.valid"
        >
          {{ "NEXT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step clientForm [stepControl]="clientForm">
    <form [formGroup]="clientForm" class="w-full">
      <ng-template matStepLabel>{{ "CLIENT" | translate }}</ng-template>

      <div class="grid grid-cols-12 gap-6">
        <!-- Client Name -->
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NAME" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="client_name" />
            <mat-error
              *ngIf="clientForm.get('client_name')?.hasError('required')"
            >
              {{ "CLIENT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Client Person -->
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_PERSON" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_person" />
            <mat-error
              *ngIf="clientForm.get('contact_person')?.hasError('required')"
            >
              {{ "CLIENT_PERSON_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Client Number -->
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NUMBER" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_number" />
            <mat-error
              *ngIf="clientForm.get('contact_number')?.hasError('required')"
            >
              {{ "CLIENT_NUMBER_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Client Number -->
        <div class="col-span-6">
          <mat-label>{{ "Khasra_no" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="khasra_no" />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "Area" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="area" />
          </mat-form-field>
        </div>
        <!-- State -->
        <div class="col-span-6">
          <mat-label>{{ "STATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="state"
              (selectionChange)="getdistricts()"
            >
              <mat-option value="">{{ "SELECT_STATE" | translate }}</mat-option>
              <mat-option *ngFor="let state of allState" [value]="state">{{
                state
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="clientForm.get('state')?.hasError('required')">
              {{ "STATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- District -->
        <div class="col-span-6">
          <mat-label>{{ "DISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="district"
              (selectionChange)="getsubdistricts()"
            >
              <mat-option value="">{{
                "SELECT_DISTRICT" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let district of allDistricts"
                [value]="district"
                >{{ district }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="clientForm.get('district')?.hasError('required')">
              {{ "DISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- SubDistrict -->
        <div class="col-span-6">
          <mat-label>{{ "SUBDISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="subDistrict"
              (selectionChange)="getvillages()"
            >
              <mat-option value="">{{
                "SELECT_SUBDISTRICT" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let subdistrict of allSubDistricts"
                [value]="subdistrict"
                >{{ subdistrict }}</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="clientForm.get('subDistrict')?.hasError('required')"
            >
              {{ "SUBDISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Villages -->
        <div class="col-span-6">
          <mat-label>{{ "VILLAGES" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="villages">
              <mat-option value="">{{
                "SELECT_VILLAGE" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let village of allVillage"
                [value]="village"
                >{{ village }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="clientForm.get('villages')?.hasError('required')">
              {{ "VILLAGES_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="w-60"
          (click)="onSubmit()"
        >
          {{
            projectId
              ? ("UPDATE_PROJECT" | translate)
              : ("SAVE_PROJECT" | translate)
          }}
        </button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>
